import { ChatUserActionType } from '../../types/chatUserType'

export const setUpChatUser = (data : any) => {
    return {type: ChatUserActionType.SET_UP_CHAT_USER, payload: data}
}

export const addToChatUser = (data : any) => {
    return {type: ChatUserActionType.UPDATE_CHAT_USER, payload: data}
}
